import {useEffect,useState,useCallback} from "react";
import {BrowserRouter,useNavigate,useLocation,Routes,Route,Link} from "react-router-dom";
import {ArrowRight,CalendarDays,ChevronDown,ChevronRight,Clock3,Instagram,MapPin,Menu,MessageCircle,Phone,Search,Scissors,Sparkles,X} from "lucide-react";
import Admin from "./Admin";
import "./App.css";

export const API=`${process.env.REACT_APP_BACKEND_URL}/api`;

// Real Smit Studio photos (uploaded by owner)
const salon={
  storefront:"https://customer-assets-jai6qajn.emergentagent.net/job_smit-grooming-hub/artifacts/6n6h39bo_Smit%20Studio1.jpg%20.jpeg",
  interior1:"https://customer-assets-jai6qajn.emergentagent.net/job_smit-grooming-hub/artifacts/z5vt1398_Smit%20Studio2.jpg%20.jpeg",
  products1:"https://customer-assets-jai6qajn.emergentagent.net/job_smit-grooming-hub/artifacts/wipm52yk_Smit%20Studio3.jpg%20.jpeg",
  products2:"https://customer-assets-jai6qajn.emergentagent.net/job_smit-grooming-hub/artifacts/nf977v7h_Smit%20Studio4.jpg%20.jpeg",
  products3:"https://customer-assets-jai6qajn.emergentagent.net/job_smit-grooming-hub/artifacts/5eei2kgz_Smit%20Studio5.jpg%20.jpeg",
};

// Editorial gap-fillers for service category cards (Indian salon imagery, warm tones)
const catImages={
  "hair-cuts-styling":"https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=900&q=85",
  "hair-colour":"https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?auto=format&fit=crop&w=900&q=85",
  "hair-treatments-smoothing-repair":"https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?auto=format&fit=crop&w=900&q=85",
  "men-s-grooming":"https://images.unsplash.com/photo-1622286342621-4bd786c2447c?auto=format&fit=crop&w=900&q=85",
  "beauty-skin":"https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?auto=format&fit=crop&w=900&q=85",
  "threading-waxing":"https://images.unsplash.com/photo-1519415943484-9fa1873496d4?auto=format&fit=crop&w=900&q=85",
  "nails":"https://images.unsplash.com/photo-1604654894610-df63bc536371?auto=format&fit=crop&w=900&q=85",
  "kids":"https://images.unsplash.com/photo-1580618672591-eb180b1a973f?auto=format&fit=crop&w=900&q=85",
};

const galleryPhotos=[salon.interior1,salon.products1,salon.products2,salon.products3,catImages["hair-cuts-styling"],catImages["beauty-skin"]];

const contact={phone:"+91 98192 25222",tel:"tel:+919819225222",wa:"https://wa.me/919819225222",address:"Shop No. 10, Makwana Road, Crescent Landmark Society, Marol, Andheri East, Mumbai, Maharashtra 400059",maps:"https://www.google.com/maps/dir/?api=1&destination=Smit%20Studio%20The%20Family%20Salon%20Marol%20Andheri%20East%20Mumbai",instagram:"https://www.instagram.com/smitstudio_salon/"};

function useData(){
  const [services,setServices]=useState([]);
  const [settings,setSettings]=useState({});
  const [offers,setOffers]=useState([]);
  const [gallery,setGallery]=useState([]);
  useEffect(()=>{
    Promise.all([
      fetch(`${API}/services`).then(r=>r.json()),
      fetch(`${API}/settings`).then(r=>r.json()),
      fetch(`${API}/offers`).then(r=>r.json()),
      fetch(`${API}/gallery`).then(r=>r.json()),
    ]).then(([a,b,c,d])=>{setServices(a||[]);setSettings(b||{});setOffers(c||[]);setGallery(d||[])}).catch(()=>{});
  },[]);
  return {services,settings,offers,gallery};
}

function Shell({children}){
  const [open,setOpen]=useState(false);
  const loc=useLocation();
  useEffect(()=>{setOpen(false)},[loc.pathname]);
  const isAdmin=loc.pathname.startsWith("/admin");
  if(isAdmin) return <>{children}</>;
  return <>
    <TopStrip/>
    <header className="nav">
      <Link className="brand" to="/" data-testid="brand-link"><span>SMIT STUDIO</span><small>स्मित स्टुडिओ · THE FAMILY SALON</small></Link>
      <nav className={open?"navlinks open":"navlinks"}>
        {["Services","Menu","Offers","Gallery","About","Contact"].map(x=><Link key={x} to={`/${x.toLowerCase()}`} className={loc.pathname===`/${x.toLowerCase()}`?"active":""} data-testid={`nav-${x.toLowerCase()}-link`}>{x}</Link>)}
        <Link className="navbook" to="/book" data-testid="nav-book-link">Book appointment <ArrowRight size={15}/></Link>
      </nav>
      <button className="iconbutton mobilemenu" onClick={()=>setOpen(!open)} aria-label="Open menu" data-testid="mobile-menu-button">{open?<X/>:<Menu/>}</button>
    </header>
    {children}
    <div className="stickybar">
      <a href={contact.tel} data-testid="sticky-call-link"><Phone size={16}/>Call</a>
      <a href={contact.wa} target="_blank" rel="noreferrer" data-testid="sticky-whatsapp-link"><MessageCircle size={16}/>WhatsApp</a>
      <Link to="/book" data-testid="sticky-book-link"><CalendarDays size={16}/>Book</Link>
      <a href={contact.maps} target="_blank" rel="noreferrer" data-testid="sticky-directions-link"><MapPin size={16}/>Directions</a>
    </div>
  </>;
}

function TopStrip(){
  const [dismissed,setDismissed]=useState(sessionStorage.getItem("annDismissed")==="1");
  const [ann,setAnn]=useState(null);
  const [topOffer,setTopOffer]=useState(null);
  useEffect(()=>{
    fetch(`${API}/settings`).then(r=>r.json()).then(s=>{if(s?.announcement?.enabled&&s.announcement.text)setAnn(s.announcement)});
    fetch(`${API}/offers`).then(r=>r.json()).then(list=>{const o=(list||[]).find(x=>x.placement==="top_bar");if(o)setTopOffer(o)});
  },[]);
  if(dismissed) return null;
  const close=()=>{sessionStorage.setItem("annDismissed","1");setDismissed(true)};
  if(topOffer) return <div className="topstrip offer" data-testid="top-offer-strip">
    <span><Sparkles size={13}/> <b>{topOffer.discountLabel||"Offer"}</b> · {topOffer.title}{topOffer.subtitle?` — ${topOffer.subtitle}`:""}</span>
    <Link to="/offers" className="topstrip-cta" data-testid="top-offer-link">See details <ArrowRight size={12}/></Link>
    <button onClick={close} aria-label="Dismiss" data-testid="top-offer-dismiss"><X size={14}/></button>
  </div>;
  if(!ann) return null;
  return <div className="topstrip" data-testid="announcement-strip">
    <span><Sparkles size={13}/> {ann.text}</span>
    <button onClick={close} aria-label="Dismiss" data-testid="announcement-dismiss"><X size={14}/></button>
  </div>;
}

function OfferRibbon({offers}){
  if(!offers?.length) return null;
  const top=offers[0];
  return <div className="heroribbon" data-testid="hero-offer-ribbon"><span>{top.discountLabel||"Offer"}</span><span>{top.title}</span></div>;
}

function Hero({offers}){
  return <section className="hero">
    <div className="heroimage" style={{backgroundImage:`url(${salon.storefront})`}}/>
    <div className="herooverlay"/>
    <div className="hero-content">
      <p className="eyebrow">MAROL · ANDHERI EAST · MUMBAI</p>
      <h1>Smit Studio<br/><em>The Family Salon</em></h1>
      <p className="hero-copy">Hair, beauty and grooming for the whole family.</p>
      <div className="hero-meta">
        <span><Clock3 size={15}/>Open 9 AM – 10 PM, all days</span>
        <span><MapPin size={15}/>Marol, Andheri East</span>
      </div>
      <div className="actions">
        <Link className="button gold" to="/book" data-testid="hero-book-button">Book an appointment <ArrowRight size={16}/></Link>
        <Link className="button ghost" to="/services" data-testid="hero-services-button">View services</Link>
      </div>
      <div className="quick">
        <a href={contact.wa} target="_blank" rel="noreferrer" data-testid="hero-whatsapp-link"><MessageCircle size={17}/>WhatsApp</a>
        <a href={contact.tel} data-testid="hero-call-link"><Phone size={17}/>Call us</a>
      </div>
      <OfferRibbon offers={offers}/>
    </div>
    <div className="hero-edge"><Scissors size={17}/><span>FAMILY · HAIR · BEAUTY · GROOMING</span></div>
  </section>;
}

function OffersBand({offers}){
  if(!offers?.length) return null;
  return <section className="offersband" data-testid="offers-section">
    <div className="sectionhead">
      <div><p className="eyebrow goldtext">Right now at Smit Studio</p><h2>Current offers.</h2></div>
    </div>
    <div className="offerscards">
      {offers.slice(0,3).map((o,i)=><div className="offercard" key={i} data-testid={`offer-card-${i}`}>
        {o.discountLabel&&<span className="offertag">{o.discountLabel}</span>}
        <h3>{o.title}</h3>
        {o.subtitle&&<p>{o.subtitle}</p>}
        {o.ctaType==="book"?<Link className="textlink" to="/book">Book this offer <ArrowRight size={15}/></Link>
          :o.ctaType==="whatsapp"?<a className="textlink" href={`${contact.wa}?text=${encodeURIComponent("Hi, I'd like to know more about: "+o.title)}`} target="_blank" rel="noreferrer">Ask on WhatsApp <ArrowRight size={15}/></a>:null}
      </div>)}
    </div>
  </section>;
}

function ProductsStrip({show}){
  if(!show) return null;
  return <section className="products" data-testid="products-strip">
    <div className="sectionhead">
      <div><p className="eyebrow">Professional products we use</p><h2>Trusted brands,<br/><em>on our shelves.</em></h2></div>
      <p className="lead">Schwarzkopf · L'Oréal · Wella · Igora · GK Hair · Protein Kera.</p>
    </div>
    <div className="productsgrid">
      <img src={salon.products1} alt="Professional colour and treatment products on the salon shelf"/>
      <img src={salon.products2} alt="Salon retail wall with Schwarzkopf, L'Oréal and Wella products"/>
      <img src={salon.products3} alt="Premium hair care and colour range at Smit Studio"/>
    </div>
  </section>;
}

function Home(){
  const {services,settings,offers,gallery}=useData();
  const galleryImgs=gallery.length?gallery.slice(0,6).map(g=>g.imageUrl):galleryPhotos;
  return <>
    <Hero offers={offers}/>
    <main>
      <section className="intro split">
        <div><p className="eyebrow">A considered salon visit</p><h2>Your neighbourhood destination for hair, beauty and grooming in Marol.</h2></div>
        <div><p className="lead">A modern, premium-but-approachable family salon for men, women and kids. Find your next look, take a little time for yourself, and leave feeling ready for what's next.</p><Link className="textlink" to="/about" data-testid="intro-about-link">More about Smit Studio <ArrowRight size={16}/></Link></div>
      </section>

      <OffersBand offers={offers}/>

      <section className="darkband">
        <div className="sectionhead">
          <div><p className="eyebrow goldtext">Find your next look</p><h2>Everything for your<br/><em>next salon visit.</em></h2></div>
          <Link className="button outline" to="/menu" data-testid="home-menu-link">Explore the menu <ArrowRight size={16}/></Link>
        </div>
        <div className="categorygrid">
          {services.slice(0,6).map((s,i)=><Link to="/menu" className="category" key={s.id} data-testid={`category-card-${s.id}`}>
            <img src={catImages[s.id]||catImages["hair-cuts-styling"]} alt={s.category}/>
            <div><span>0{i+1}</span><h3>{s.category}</h3><p>{s.description}</p></div>
            <ArrowRight size={18}/>
          </Link>)}
        </div>
      </section>

      <ProductsStrip show={settings.productsWeUseEnabled!==false}/>

      <section className="why split">
        <div><p className="eyebrow">Why Smit Studio</p><h2>Good hair days,<br/><em>made for real life.</em></h2></div>
        <div className="points">
          <p><b>01</b><span><strong>Family-friendly.</strong> Men, women and kids — all welcome.</span></p>
          <p><b>02</b><span><strong>One roof.</strong> Hair, beauty and grooming in one considered space.</span></p>
          <p><b>03</b><span><strong>Marol, made easy.</strong> Conveniently located in Andheri East.</span></p>
          <p><b>04</b><span><strong>Clean & professional.</strong> A calm space you'll want to return to.</span></p>
        </div>
      </section>

      <section className="gallery-preview">
        <div className="sectionhead">
          <div><p className="eyebrow">The studio</p><h2>A glimpse inside.</h2></div>
          <Link className="textlink" to="/gallery" data-testid="home-gallery-link">View gallery <ArrowRight size={16}/></Link>
        </div>
        <div className="gallerygrid">
          {galleryImgs.map((p,i)=><img key={i} src={p} alt={`Smit Studio salon view ${i+1}`} data-testid={`gallery-image-${i+1}`}/>)}
        </div>
      </section>

      <section className="instagram-follow">
        <div>
          <p className="eyebrow goldtext">Follow along</p>
          <h2>@smitstudio_salon<br/><em>on Instagram.</em></h2>
          <p className="lead">Everyday looks, new services and life inside the studio.</p>
        </div>
        <a className="button gold" href={contact.instagram} target="_blank" rel="noreferrer" data-testid="home-instagram-link"><Instagram size={16}/> Follow on Instagram</a>
      </section>

      <section className="cta">
        <div><p className="eyebrow goldtext">Your next visit starts here</p><h2>Ready for your next<br/><em>salon appointment?</em></h2></div>
        <div className="ctalinks">
          <Link className="button gold" to="/book" data-testid="cta-book-button">Book now <ArrowRight size={16}/></Link>
          <a href={contact.wa} target="_blank" rel="noreferrer" data-testid="cta-whatsapp-link"><MessageCircle size={16}/> WhatsApp us</a>
          <a href={contact.tel} data-testid="cta-call-link"><Phone size={16}/> Call {contact.phone}</a>
          <a href={contact.maps} target="_blank" rel="noreferrer" data-testid="cta-directions-link"><MapPin size={16}/> Get directions</a>
        </div>
      </section>

      <section className="location">
        <div>
          <p className="eyebrow">Find us</p>
          <h2>Marol, Andheri East.</h2>
          <p className="lead">{contact.address}</p>
          <a className="button outline-dark" href={contact.maps} target="_blank" rel="noreferrer" data-testid="location-directions-link"><MapPin size={16}/> Get directions</a>
        </div>
        <iframe title="Smit Studio location" src="https://www.google.com/maps?q=Smit%20Studio%20The%20Family%20Salon%20Marol%20Andheri%20East%20Mumbai&output=embed" loading="lazy"/>
      </section>
    </main>
    <Footer/>
  </>;
}

function MenuPage(){
  const {services,settings}=useData();
  const [q,setQ]=useState("");
  const [expanded,setExpanded]=useState("");
  useEffect(()=>{if(services.length&&!expanded)setExpanded(services[0].id)},[services,expanded]);
  const globalMode=settings.priceDisplayMode||"show";
  return <>
    <PageIntro kicker="The menu" title={<>A menu made for<br/><em>every kind of day.</em></>} text="Browse by category, choose what feels right, and book when you're ready."/>
    <main className="menu-page">
      <div className="searchbox"><Search size={18}/><input value={q} onChange={e=>setQ(e.target.value)} placeholder="Search the menu" data-testid="menu-search-input"/></div>
      {services.map((s,i)=>{
        const list=(s.services||[]).filter(x=>x.name.toLowerCase().includes(q.toLowerCase()));
        if(q&&!list.length) return null;
        const isOpen=expanded===s.id||!!q;
        return <section className="menu-section" key={s.id}>
          <button className="menu-toggle" onClick={()=>setExpanded(isOpen?"":s.id)} data-testid={`menu-category-${s.id}-toggle`}>
            <span><small>0{i+1}</small><b>{s.category}</b></span>
            {isOpen?<ChevronDown/>:<ChevronRight/>}
          </button>
          {isOpen&&<div className="menu-items">
            {list.map((x)=><div className="menu-row" key={x.id}>
              <span>{x.name}</span>
              <span data-testid={`menu-price-${x.id}`}>{globalMode==="hide_all"?"On request":x.priceDisplay}</span>
            </div>)}
            <Link className="textlink" to="/book" data-testid={`menu-book-${s.id}-link`}>Book this category <ArrowRight size={15}/></Link>
          </div>}
        </section>;
      })}
      <p className="disclaimer" data-testid="price-disclaimer">{settings.priceDisclaimer||"Prices are indicative and may vary. Please confirm final pricing at the salon."}</p>
    </main>
    <Footer/>
  </>;
}

function PageIntro({kicker,title,text}){return <section className="pageintro"><p className="eyebrow">{kicker}</p><h1>{title}</h1><p className="lead">{text}</p></section>}

function Book(){
  const {services}=useData();
  const [form,setForm]=useState({name:"",phone:"",serviceSummary:"",date:"",timeSlot:"",notes:""});
  const [done,setDone]=useState(false);
  const [slots,setSlots]=useState([]);
  const [err,setErr]=useState("");
  useEffect(()=>{if(form.date)fetch(`${API}/availability?date=${form.date}`).then(r=>r.json()).then(x=>setSlots(x.slots||[]))},[form.date]);
  const update=e=>setForm({...form,[e.target.name]:e.target.value});
  const submit=async e=>{
    e.preventDefault();setErr("");
    const params=new URLSearchParams(window.location.search);
    const src={utmSource:params.get("utm_source")||"",utmMedium:params.get("utm_medium")||"",utmCampaign:params.get("utm_campaign")||"",referrer:document.referrer};
    const r=await fetch(`${API}/bookings`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({...form,serviceIds:[],totalDurationMinutes:30,source:src})});
    const d=await r.json();
    if(r.ok) setDone(true); else setErr(d.detail||"Please review the details and try again.");
  };
  if(done) return <>
    <PageIntro kicker="Appointment requested" title={<>You're on the<br/><em>right track.</em></>} text="Your appointment request is saved. Confirm the details with us on WhatsApp so we can take care of the rest."/>
    <main className="success">
      <div className="successmark">✓</div>
      <h2>Thanks, {form.name}.</h2>
      <p>{form.date} · {form.timeSlot}<br/>{form.serviceSummary}</p>
      <a className="button gold" href={`${contact.wa}?text=${encodeURIComponent(`Hi Smit Studio, I've requested an appointment for ${form.name} on ${form.date} at ${form.timeSlot} (${form.serviceSummary}).`)}`} target="_blank" rel="noreferrer" data-testid="booking-whatsapp-confirm">Confirm on WhatsApp <MessageCircle size={16}/></a>
      <Link className="textlink" to="/" data-testid="booking-home-link">Back to home</Link>
    </main>
    <Footer/>
  </>;
  const minDate=new Date().toISOString().split("T")[0];
  return <>
    <PageIntro kicker="Book an appointment" title={<>Make time for<br/><em>yourself.</em></>} text="Tell us what you're looking for and we'll keep your visit simple."/>
    <main className="booking">
      <form onSubmit={submit} className="bookingform">
        <label>Name<input name="name" required value={form.name} onChange={update} placeholder="Your name" data-testid="booking-name-input"/></label>
        <label>Phone<input name="phone" required pattern="[6-9][0-9]{9}" value={form.phone} onChange={update} placeholder="10-digit mobile number" data-testid="booking-phone-input"/></label>
        <label>Service interest<select name="serviceSummary" required value={form.serviceSummary} onChange={update} data-testid="booking-service-select"><option value="">Choose a category</option>{services.map(s=><option key={s.id}>{s.category}</option>)}</select></label>
        <div className="formrow">
          <label>Date<input type="date" name="date" required min={minDate} value={form.date} onChange={update} data-testid="booking-date-input"/></label>
          <label>Time<select name="timeSlot" required value={form.timeSlot} onChange={update} data-testid="booking-time-select"><option value="">Choose a time</option>{slots.map(s=><option key={s.value}>{s.label}</option>)}</select></label>
        </div>
        <label>Anything we should know?<textarea name="notes" value={form.notes} onChange={update} placeholder="Optional note" data-testid="booking-notes-input"/></label>
        {err&&<p className="error" role="alert" data-testid="booking-error">{err}</p>}
        <button className="button gold submit" type="submit" data-testid="booking-submit-button">Request appointment <ArrowRight size={16}/></button>
        <p className="formnote">Your request is saved here, then confirmed with you on WhatsApp.</p>
      </form>
    </main>
    <Footer/>
  </>;
}

function GalleryPage(){
  const {gallery}=useData();
  const imgs=gallery.length?gallery.map(g=>g.imageUrl):galleryPhotos.concat([salon.storefront]);
  return <>
    <PageIntro kicker="Gallery" title={<>Inside the<br/><em>studio.</em></>} text="A glimpse at the space where your next visit begins."/>
    <main className="gallerypage">
      <div className="masonry">{imgs.map((src,i)=><img key={i} src={src} alt={`Smit Studio ${i+1}`} data-testid={`gallery-page-image-${i}`} loading="lazy"/>)}</div>
    </main>
    <Footer/>
  </>;
}

function ServicesPage(){
  const {services,settings}=useData();
  return <>
    <PageIntro kicker="Services" title={<>A considered edit for<br/><em>every kind of visit.</em></>} text="Browse the full menu of hair, beauty and grooming services."/>
    <main className="servicespage">
      {services.map((s,i)=><section className="servicecategory" key={s.id}>
        <div className="servicecategoryhead"><img src={catImages[s.id]||catImages["hair-cuts-styling"]} alt={s.category}/><div><p className="eyebrow">0{i+1}</p><h2>{s.category}</h2><p className="lead">{s.description}</p><Link className="textlink" to="/book">Book this category <ArrowRight size={15}/></Link></div></div>
        <div className="servicelist">{(s.services||[]).map(x=><div className="menu-row" key={x.id}><span>{x.name}</span><span>{settings.priceDisplayMode==="hide_all"?"On request":x.priceDisplay}</span></div>)}</div>
      </section>)}
      <p className="disclaimer">{settings.priceDisclaimer||"Prices are indicative and may vary. Please confirm final pricing at the salon."}</p>
    </main>
    <Footer/>
  </>;
}

function AboutPage(){
  return <>
    <PageIntro kicker="About Smit Studio" title={<>A family salon,<br/><em>made with intention.</em></>} text="A modern, approachable family salon in the heart of Marol, Andheri East."/>
    <main className="static">
      <img src={salon.interior1} alt="Inside Smit Studio The Family Salon"/>
      <div>
        <p className="lead">A premium-but-approachable space for men, women and kids. Hair, beauty and grooming under one considered roof — with professional-grade products, warm hospitality, and convenient hours.</p>
        <p className="lead">Open 9 AM – 10 PM, all days of the week.</p>
        <Link className="textlink" to="/book">Book an appointment <ArrowRight size={16}/></Link>
      </div>
    </main>
    <Footer/>
  </>;
}

function ContactPage(){
  return <>
    <PageIntro kicker="Come by sometime" title={<>Say hello,<br/><em>Marol.</em></>} text={contact.address}/>
    <main className="static">
      <img src={salon.storefront} alt="Smit Studio storefront in Marol"/>
      <div>
        <p className="lead">Shop No. 10, Makwana Road, Crescent Landmark Society, Marol, Andheri East, Mumbai, Maharashtra 400059.</p>
        <p className="lead"><Clock3 size={15} style={{verticalAlign:"middle",marginRight:6}}/>Open 9 AM – 10 PM · All days</p>
        <div className="contactactions">
          <a className="button gold" href={contact.tel} data-testid="contact-call-link"><Phone size={16}/> Call {contact.phone}</a>
          <a className="button outline-dark" href={contact.wa} target="_blank" rel="noreferrer" data-testid="contact-whatsapp-link"><MessageCircle size={16}/> WhatsApp</a>
          <a className="button outline-dark" href={contact.maps} target="_blank" rel="noreferrer" data-testid="contact-directions-link"><MapPin size={16}/> Get directions</a>
        </div>
      </div>
    </main>
    <Footer/>
  </>;
}

function Footer(){
  return <footer>
    <div className="footerbrand"><span>SMIT STUDIO</span><small>स्मित स्टुडिओ · THE FAMILY SALON</small></div>
    <div className="footerinfo">
      <p>{contact.address}</p>
      <a href={contact.tel} data-testid="footer-phone-link">{contact.phone}</a>
      <span>9:00 AM – 10:00 PM · All days</span>
    </div>
    <div className="footerlinks">
      <Link to="/book" data-testid="footer-book-link">Book appointment <ArrowRight size={15}/></Link>
      <a href={contact.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram-link"><Instagram size={16}/> @smitstudio_salon</a>
      <a href={contact.maps} target="_blank" rel="noreferrer" data-testid="footer-directions-link"><MapPin size={15}/> Get directions</a>
    </div>
    <p className="copyright">© {new Date().getFullYear()} Smit Studio The Family Salon. All rights reserved.</p>
  </footer>;
}

function OffersPage(){
  const [offers,setOffers]=useState([]);
  const [enabled,setEnabled]=useState(true);
  useEffect(()=>{
    Promise.all([fetch(`${API}/offers`).then(r=>r.json()),fetch(`${API}/settings`).then(r=>r.json())])
      .then(([o,s])=>{setOffers(o||[]);setEnabled(!!s?.offersEnabled)});
  },[]);
  return <>
    <PageIntro kicker="Current offers" title={<>A little something<br/><em>on us.</em></>} text="Live offers from Smit Studio. Book online or say hello on WhatsApp to redeem."/>
    <main className="offerspage">
      {enabled&&offers.length?<div className="offers-listing" data-testid="offers-listing">
        {offers.map((o,i)=><article className="offercard light" key={i} data-testid={`offers-page-card-${i}`}>
          {o.discountLabel&&<span className="offertag">{o.discountLabel}</span>}
          <h2>{o.title}</h2>
          {o.subtitle&&<p className="lead">{o.subtitle}</p>}
          <p className="offerdates">Valid {o.startDate} → {o.endDate}</p>
          <div className="actions">
            {o.ctaType==="book"&&<Link className="button gold" to="/book" data-testid={`offers-page-book-${i}`}>Book this offer <ArrowRight size={16}/></Link>}
            {o.ctaType==="whatsapp"&&<a className="button gold" href={`${contact.wa}?text=${encodeURIComponent("Hi Smit Studio, I'd like to know more about: "+o.title)}`} target="_blank" rel="noreferrer" data-testid={`offers-page-wa-${i}`}><MessageCircle size={16}/> Ask on WhatsApp</a>}
            <Link className="button outline-dark" to="/menu">Browse the menu <ArrowRight size={16}/></Link>
          </div>
        </article>)}
      </div>:<div className="offers-empty" data-testid="offers-empty">
        <p className="lead">No live offers just now. Follow along on Instagram <a href={contact.instagram} target="_blank" rel="noreferrer">@smitstudio_salon</a> — new offers show up here first.</p>
        <Link className="button gold" to="/book">Book an appointment <ArrowRight size={16}/></Link>
      </div>}
    </main>
    <Footer/>
  </>;
}

function App(){
  return <BrowserRouter>
    <Shell>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/menu" element={<MenuPage/>}/>
        <Route path="/book" element={<Book/>}/>
        <Route path="/services" element={<ServicesPage/>}/>
        <Route path="/gallery" element={<GalleryPage/>}/>
        <Route path="/offers" element={<OffersPage/>}/>
        <Route path="/about" element={<AboutPage/>}/>
        <Route path="/contact" element={<ContactPage/>}/>
        <Route path="/admin/*" element={<Admin/>}/>
        <Route path="*" element={<Home/>}/>
      </Routes>
    </Shell>
  </BrowserRouter>;
}

export default App;
